import { render, staticRenderFns } from "./mobile_changeAddress.vue?vue&type=template&id=2e5a53c3&scoped=true&"
import script from "./mobile_changeAddress.vue?vue&type=script&lang=js&"
export * from "./mobile_changeAddress.vue?vue&type=script&lang=js&"
import style0 from "./mobile_changeAddress.vue?vue&type=style&index=0&id=2e5a53c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5a53c3",
  null
  
)

export default component.exports